import { api } from './client.js';

export const runStats        = (id, p) => api.post(`/layers/${id}/analytics/stats`, p);
export const runFilter       = (id, p) => api.post(`/layers/${id}/analytics/filter`, p);
export const runSpatialJoin  = (id, p) => api.post(`/layers/${id}/analytics/spatial-join`, p);
export const runBuffer       = (id, p) => api.post(`/layers/${id}/analytics/buffer`, p);
export const runNearest      = (id, p) => api.post(`/layers/${id}/analytics/nearest`, p);
export const runHotspot      = (id, p) => api.post(`/layers/${id}/analytics/hotspot`, p);
export const runZonal        = (id, p) => api.post(`/layers/${id}/analytics/zonal`, p);
export const runBreaks       = (id, p) => api.post(`/layers/${id}/analytics/breaks`, p);
export const runCategories   = (id, p) => api.post(`/layers/${id}/analytics/categories`, p);
